module.exports = __webpack_public_path__ + "img/Gallery_2_06.664bc117.jpeg";